import { AiFillInstagram, AiFillPicture } from "react-icons/ai";
import { IoLogoGameControllerB } from "react-icons/io";
import { useHistory, useLocation } from "react-router-dom";
import Logo from "../Logo";
import { StyledDiv, StyledHeader, StyledHolder } from "./styles";
import { FaUser } from "react-icons/fa";
import { useState, useEffect, useCallback } from "react";
import { useAuth } from "../../../contexts/AuthContext";
import { Avatar } from "../Avatar";
import UserMenu from "../UserMenu";

export default function Header() {
  const [isPageOnTop, setIsPageOnTop] = useState(true);
  const [userPopUp, setUserPopUp] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const [hidden, setHidden] = useState(
    location.pathname.includes("/jogos/") ||
      location.pathname.includes("/galeria/")
  );

  const { user } = useAuth();

  const handleClick = (path: string) => {
    history.push(`/${path}`);
  };

  const handleUserPopUp = useCallback(
    () => setUserPopUp((prev) => !prev),
    [setUserPopUp]
  );

  useEffect(() => {
    const scrollEvent = (e: any) => {
      if (window.scrollY !== 0) {
        setIsPageOnTop(false);
      } else {
        setIsPageOnTop(true);
      }
    };
    document.addEventListener("scroll", scrollEvent, true);
    document.addEventListener("touchmove", scrollEvent, true);

    return () => {
      document.removeEventListener("scroll", scrollEvent);
      document.removeEventListener("touchmove", scrollEvent);
    };
  }, []);

  useEffect(() => {
    setHidden(
      location.pathname.includes("/jogos/") ||
        location.pathname.includes("/galeria/")
    );
  }, [location]);

  return (
    <>
      {!hidden && (
        <>
          <StyledHolder isFixed={isPageOnTop} className="holder"></StyledHolder>
          <StyledHeader isFixed={isPageOnTop}>
            <div className="container">
              <div className="container_box">
                <Logo isPageOnTop={isPageOnTop} />
                <section>
                  <StyledDiv
                    color="var(--blue50)"
                    onClick={() =>
                      window.open(
                        "https://www.instagram.com/valentin.cabral.rossi/?igshid=YmMyMTA2M2Y="
                      )
                    }
                  >
                    <AiFillInstagram size={40} />
                    <p>Instagram</p>
                  </StyledDiv>
                  <StyledDiv
                    color="var(--blue50)"
                    onClick={() => handleClick("galeria")}
                  >
                    <AiFillPicture size={40} />
                    <p>Galeria</p>
                  </StyledDiv>

                  <StyledDiv
                    color="var(--blue50)"
                    onClick={() => handleClick("jogos")}
                  >
                    <IoLogoGameControllerB size={40} />
                    <p>Jogos</p>
                  </StyledDiv>
                  {/* <StyledDiv
								color="var(--blue50)"
								onClick={() => handleClick("construindo")}
							>
								<GiWhiteBook size={40} />
								<p>Estudos</p>
							</StyledDiv> */}
                  <StyledDiv
                    color="var(--blue50)"
                    dontScale={userPopUp}
                    onClick={() =>
                      !!user
                        ? handleUserPopUp()
                        : window.location.href = (
                            String(process.env.REACT_APP_LOGIN_URL)
                          )
                    }
                  >
                    {!!user && !!user?.us ? (
                      <>
                        <Avatar name={user?.us || "us"} />
                        <p>{user?.us}</p>
                      </>
                    ) : (
                      <>
                        <FaUser size={40} />
                        <p>Entrar</p>
                      </>
                    )}

                    {userPopUp && <UserMenu />}
                  </StyledDiv>
                </section>
              </div>
            </div>
          </StyledHeader>
        </>
      )}
    </>
  );
}
